import { Form, Select, Spin } from 'antd';
import React, { Fragment, memo, useCallback, useEffect } from 'react';
import useDebouncedSearch from '../../../../../../../hooks/useDebouncedSearch';
import listIcon from '../../../../../../../resource/forms/ListRectangular.svg';
import useAddresses from '../../../../../queries/useAddresses';
import styles from '../../../modalStyles.module.scss';

const AddressField = ({
  getFieldDecorator,
  setFieldsValue,
  selectedAddress,
  setSelectedAddress,
  editingFacility,
}) => {
  const [_addrSearch, setAddrSearch, debouncedAddrSearch] =
    useDebouncedSearch();
  const { data: addresses, isFetching: addressesLoading } =
    useAddresses(debouncedAddrSearch);
  const onSearchAddress = useCallback(
    (search) => setAddrSearch(search),
    [setAddrSearch]
  );

  useEffect(() => {
    setFieldsValue({ house: selectedAddress });
  }, [selectedAddress]);

  return (
    <Form.Item label="Адрес">
      {getFieldDecorator('house', {
        preserve: true,
        rules: [
          {
            required: true,
            message: 'Выберите адрес.',
          },
        ],
      })(<Fragment />)}
      <Select
        defaultValue={editingFacility?.house.id}
        showSearch
        placeholder={'Начните вводить'}
        className={styles.address}
        onSearch={onSearchAddress}
        filterOption={false}
        notFoundContent={addressesLoading && <Spin size="small" />}
        loading={addressesLoading}
        suffixIcon={
          <div className={styles.iconAddressList}>
            <img src={listIcon} alt={''} />
          </div>
        }
      >
        {[editingFacility?.house, ...addresses].map(
          (address) =>
            !!address && (
              <Select.Option
                onClick={() => setSelectedAddress(address)}
                key={address.id}
                value={address.id}
              >
                {address.fullAddress}
              </Select.Option>
            )
        )}
      </Select>
    </Form.Item>
  );
};

export default AddressField;
